import {
  Box,
  Table as ReactTable,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core'

import { EmptyState } from '@/components/empty-state'
import { UseGetWeedDiagnosesResult } from '@/hooks/queries/use-get-weed-diagnoses'

import { useStyles } from './styles'
import Row from './table-rows'

type TableProps = {
  diagnoses: UseGetWeedDiagnosesResult[]
}

const Table = ({ diagnoses }: TableProps) => {
  const classes = useStyles()

  return diagnoses.length ? (
    <Box width='100%' overflow='auto'>
      <ReactTable
        aria-label='collapsible table'
        padding='none'
        className={classes.table}
      >
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography variant='body2' color='textSecondary'>
                Data do cadastro
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='body2' color='textSecondary'>
                Nome do diagnóstico
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='body2' color='textSecondary'>
                Projeto
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='body2' color='textSecondary'>
                Tags
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='body2' color='textSecondary' align='center'>
                Status
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='body2' color='textSecondary' align='center'>
                Mais
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {diagnoses.map((row) => (
            <Row key={row.id} row={row} />
          ))}
        </TableBody>
      </ReactTable>
    </Box>
  ) : (
    <Box
      width='100%'
      height='100%'
      display='flex'
      alignItems='center'
      justifyContent='center'
    >
      <EmptyState
        description='Nenhum diagnóstico encontrado'
        srcImage='assets/img/envelope.svg'
      />
    </Box>
  )
}

export default Table
